package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageOptimizer
import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.model.ImageData
import fr.manyverse.app.domain.repository.GmInventoryRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.validation.ImageValidator

class UploadGmInventoryItemImageUseCase(
    private val imageStorageRepository: ImageStorageRepository,
    private val gmInventoryRepository: GmInventoryRepository,
    private val imageOptimizer: ImageOptimizer
) {
    suspend operator fun invoke(
        tableId: String,
        itemId: String,
        imageData: ImageData
    ): Result<String> {
        ImageValidator.validate(imageData).onFailure {
            return Result.failure(it)
        }

        val optimized = imageOptimizer.optimize(imageData).getOrElse {
            return Result.failure(it)
        }

        val uploadResult = imageStorageRepository.upload(ImageTarget.GmInventoryItem(tableId, itemId), optimized)
        if (uploadResult.isFailure) return uploadResult

        val imagePath = uploadResult.getOrThrow()
        gmInventoryRepository.updateImageUrl(itemId, imagePath)
        return Result.success(imagePath)
    }
}
